export const serviceTypesDomestic = [
    { key: 'FedEx First Overnight®', value: 'FIRST_OVERNIGHT' },
    { key: 'FedEx First Overnight® Freight', value: 'FEDEX_FIRST_FREIGHT' },
    { key: 'FedEx 1Day® Freight', value: 'FEDEX_1_DAY_FREIGHT' },
    { key: 'FedEx 2Day® Freight', value: 'FEDEX_2_DAY_FREIGHT' },
    { key: 'FedEx 3Day® Freight', value: 'FEDEX_3_DAY_FREIGHT' },
    { key: 'FedEx International Ground® and FedEx Domestic Ground®', value: 'FEDEX_GROUND' },
    { key: 'FedEx Home Delivery®', value: 'GROUND_HOME_DELIVERY' },
    { key: 'FedEx Ground® Economy (Formerly known as FedEx SmartPost®)', value: 'SMART_POST' },
    { key: 'FedEx Priority Overnight®', value: 'PRIORITY_OVERNIGHT' },
    { key: 'FedEx Standard Overnight®', value: 'STANDARD_OVERNIGHT' },
    { key: 'FedEx 2Day®', value: 'FEDEX_2_DAY' },
    { key: 'FedEx 2Day® AM', value: 'FEDEX_2_DAY_AM' },
    { key: 'FedEx Express Saver®', value: 'FEDEX_EXPRESS_SAVER' },
]

export const serviceTypesInternational = [
    { key: 'FedEx International Priority® Express', value: 'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS' },
    { key: 'FedEx International First®', value: 'INTERNATIONAL_FIRST' },
    { key: 'FedEx International Priority®', value: 'FEDEX_INTERNATIONAL_PRIORITY' },
    { key: 'FedEx International Economy®', value: 'INTERNATIONAL_ECONOMY' },
    { key: 'FedEx International Ground® and FedEx Domestic Ground®', value: 'FEDEX_GROUND' },
    { key: 'FedEx International Priority® Freight', value: 'INTERNATIONAL_PRIORITY_FREIGHT' },
    { key: 'FedEx International Economy® Freight', value: 'INTERNATIONAL_ECONOMY_FREIGHT' },
    { key: 'FedEx® International Deferred Freight', value: 'FEDEX_INTERNATIONAL_DEFERRED_FREIGHT' },
    { key: 'FedEx International Priority DirectDistribution®', value: 'INTERNATIONAL_PRIORITY_DISTRIBUTION' },
    { key: 'FedEx International Priority DirectDistribution® Freight', value: 'INTERNATIONAL_DISTRIBUTION_FREIGHT' },
    { key: 'International Ground® Distribution (IGD)', value: 'INTL_GROUND_DISTRIBUTION' },
]

export const packageTypes = [
    { key: 'Customer Packaging, FedEx Express® Services', value: 'YOUR_PACKAGING' },
    { key: 'FedEx® Envelope', value: 'FEDEX_ENVELOPE' },
    { key: 'FedEx® Box', value: 'FEDEX_BOX' },
    { key: 'FedEx® Small Box', value: 'FEDEX_SMALL_BOX' },
    { key: 'FedEx® Medium Box', value: 'FEDEX_MEDIUM_BOX' },
    { key: 'FedEx® Large Box', value: 'FEDEX_LARGE_BOX' },
    { key: 'FedEx® Extra Large Box', value: 'FEDEX_EXTRA_LARGE_BOX' },
    { key: 'FedEx® 10kg Box', value: 'FEDEX_10KG_BOX' },
    { key: 'FedEx® 25kg Box', value: 'FEDEX_25KG_BOX' },
    { key: 'FedEx® Pak', value: 'FEDEX_PAK' },
    { key: 'FedEx® Tube', value: 'FEDEX_TUBE' }
]

export const indiciaTypes = [
    { key: 'Parcel Select (1-70 lbs) - standard for most packages', value: 'PARCEL_SELECT' },
    { key: 'Media Mail - educational materials', value: 'MEDIA_MAIL' },
    { key: 'Parcel Return', value: 'PARCEL_RETURN' },
    { key: 'Presorted Bound Printed Matter - printed materials', value: 'PRESORTED_BOUND_PRINTED_MATTER' },
    { key: 'Presorted Standard (less than 1 lb)', value: 'PRESORTED_STANDARD' }
]

export const subPackagingTypes = [
    'BAG',
    'BARREL',
    'BASKET',
    'BOX',
    'BUCKET',
    'BUNDLE',
    'CAGE',
    'CARTON',
    'CASE',
    'CHEST',
    'CONTAINER',
    'CRATE',
    'CYLINDER',
    'DRUM',
    'ENVELOPE',
    'HAMPER',
    'OTHER',
    'PACKAGE',
    'PAIL',
    'PALLET',
    'PARCEL',
    'PIECE',
    'REEL',
    'ROLL',
    'SACK',
    'SHRINKWRAPPED',
    'SKID',
    'TANK',
    'TOTEBIN',
    'TUBE',
    'UNIT'
]

export const senders = [
    {
        id: 'SJ8T',
        country: 'US',
        contactName: 'Stan Jacques',
        companyName: 'BICSI',
        address1: '8610 Hidden River Parkway',
        address2: '',
        city: 'Tampa',
        state: 'FL',
        postalCode: '33637',
        telephone: '8139791991',
        email: 'sjacques@bicsi.org',
        residential: false
    },
    {
        id: 'SENDER0893255',
        country: 'US',
        contactName: 'Ship Dept',
        companyName: 'Jackie Stevens',
        address1: '8610 Hidden River Parkway',
        address2: '',
        city: 'Tampa',
        state: 'FL',
        postalCode: '33637',
        telephone: '8139791991',
        email: '',
        residential: false
    },
    {
        id: 'SENDER224341',
        country: 'US',
        contactName: 'Jennifer Burant',
        companyName: 'BICSI',
        address1: '8610 Hidden River Parkway',
        address2: '',
        city: 'Tampa',
        state: 'FL',
        postalCode: '33637',
        telephone: '8139791991',
        email: '',
        residential: false
    }
]

export const militaryLocationsState = [
    { value: 'AA', description: 'Armed Forces Americas' },
    { value: 'AE', description: 'Armed Forces Europe' },
    { value: 'AP', description: 'Armed Forces Pacific' }
];

export const billingOptions = [
    { key: 'Sender', value: 'SENDER' },
    { key: 'Recipient', value: 'RECIPIENT' },
    { key: 'Third party', value: 'THIRD_PARTY' }
]

export const currencies = [
    { currency: 'United States Dollar', code: 'USD' }
]

export const unitsMeasure = [
    { value: 'AR', description: 'CARAT' },
    { value: 'CM', description: 'CENTIMETER' },
    { value: 'CFT', description: 'CUBIC FOOT' },
    { value: 'M3', description: 'CUBIC METER' },
    { value: 'DOZ', description: 'DOZEN' },
    { value: 'DPR', description: 'DOZEN PAIR' },
    { value: 'EA', description: 'EACH' },
    { value: 'LFT', description: 'FOOT' },
    { value: 'G', description: 'GRAM' },
    { value: 'GR', description: 'GROSS' },
    { value: 'KG', description: 'KILOGRAM' },
    { value: 'LNM', description: 'LINEAR METER' },
    { value: 'LTR', description: 'LITER' },
    { value: 'M', description: 'METER' },
    { value: 'MG', description: 'MILLIGRAM' },
    { value: 'ML', description: 'MILLILITER' },
    { value: 'NO', description: 'NUMBER' },
    { value: 'OZ', description: 'OUNCE' },
    { value: 'PR', description: 'PAIR' },
    { value: 'PCS', description: 'PIECES' },
    { value: 'LB', description: 'POUND' },
    { value: 'SFT', description: 'SQUARE FOOT' },
    { value: 'M2', description: 'SQUARE METER (M2)' },
    { value: 'SYD', description: 'SQUARE YARD' },
    { value: 'YD', description: 'YARD' }
]

export const signatureOptions = [
    { key: 'None specified', value: 'SERVICE_DEFAULT' },
    { key: 'No signature required', value: 'NO_SIGNATURE_REQUIRED' },
    { key: 'Direct signature required', value: 'DIRECT' },
    { key: 'Indirect signature required', value: 'INDIRECT' },
    { key: 'Adult signature required', value: 'ADULT' },
]

export const holdAtLocationType = [
    { key: 'Fedex authorized ship center', value: 'FEDEX_AUTHORIZED_SHIP_CENTER' },
    { key: 'Fedex office', value: 'FEDEX_OFFICE' },
    { key: 'Fedex self service location', value: 'FEDEX_SELF_SERVICE_LOCATION' },
    { key: 'Fedex staffed', value: 'FEDEX_STAFFED' },
    { key: 'Retail alliance location', value: 'RETAIL_ALLICANCE_LOCATION' },
    { key: 'Fedex ground terminal', value: 'FEDEX_GROUND_TERMINAL' },
    { key: 'Fedex onsite', value: 'FEDEX_ONSITE' }
]

export const dangerousGoodsRegulations = ['ADR', 'DOT', 'IATA', 'ORMD']

export const dangerousGoodsOptions = [
    { key: 'Hazardous materials', value: 'HAZARDOUS_MATERIALS' },
    { key: 'Battery', value: 'BATTERY' },
    { key: 'ORM-D', value: 'ORM_D' },
    { key: 'Reportable quantities', value: 'REPORTABLE_QUANTITIES' },
    { key: 'Small quantity exception', value: 'SMALL_QUANTITY_EXCEPTION' },
    { key: 'Limited quantities commodities', value: 'LIMITED_QUANTITIES_COMMODITIES' }
]

// from PDF doc - may not end up using, differs from FedEx docs
export const shipmentPurposeOld = [
    'CATALOGUE/ORDER RETURN',
    'COMMERCIAL SALE',
    'DOCUMENTS',
    'GIFT (UNSOLICITED)',
    'INTRA-COMPANY TRANSFER',
    'MARKED SAMPLES (NO RESALE)',
    'MUTILATED SAMPLES (NO RESALE)',
    'PERSONAL EFFECTS (PROHIBITED BY FEDEX GROUND)',
    'PERSONAL USE (NEW, NO RESALE)',
    'RETURN FOR REPAIR',
    'RETURN AFTER REPAIR',
    'OTHER (PLEASE SPECIFY)'
]

export const shipmentPurpose = [
    { key: 'Gift', value: 'GIFT' },
    { key: 'Not sold', value: 'NOT_SOLD' },
    { key: 'Personal effects', value: 'PERSONAL_EFFECTS' },
    { key: 'Repair and return', value: 'REPAIR_AND_RETURN' },
    { key: 'Sample', value: 'SAMPLE' },
    { key: 'Sold', value: 'SOLD' },
]

export const taxIdOptions = [
    'ABN',
    'CR',
    'EIN',
    'GST',
    'IN',
    'RFC',
    'VAT',
    'OTHER'
]

export const eeiFiling = [
    { key: 'No EEI Required', value: 'NO_EEI_REQUIRED' }
]

export const commercialInvoiceSource = [
    'My own Commercial Invoice (upload now)',
    // 'My own Commercial Invoice (upload later)',
    // 'My own Proforma',
    'Auto-generated Commercial Invoice',
    // 'Auto-generated Proforma'
]

export const certOfOriginSource = [
    'My own Certificate of Origin (upload now)',
    'My own USMCA Certification of Origin (upload now)',
    // 'My own Certification of Origin (upload later)',
    // 'Auto-generated USMCA/T-MEC/CUSMA Certification of Origin'
]

export const ftrExemptionCodes = [
    'NO EEI 30.36',
    'NO EEI 30.37(a)',
    'NO EEI 30.37(f)',
    'NO EEI 30.37(g)',
    'NO EEI 30.37(h)',
    'NO EEI 30.37(i)',
    'NO EEI 30.37(j)',
    'NO EEI 30.37(k)',
    'NO EEI 30.37(o)',
    'NO EEI 30.37(q)',
    'NO EEI 30.37(r)',
    'NO EEI 30.37(s)',
    'NO EEI 30.37(t)',
    'NO EEI 30.37(u)',
    'NO EEI 30.37(v)',
    'NO EEI 30.37(w)',
    'NO EEI 30.37(x)',
    'NO EEI 30.37(y)',
    'NO EEI 30.39',
    'NO EEI 30.40(a)',
    'NO EEI 30.40(b)',
    'NO EEI 30.40(c)',
    'NO EEI 30.40(d)',
    'NO EEI 30.2(d)(2)'
]

export const departmentNotes = [
    { code: '1099-Personal', name: 'Personal' },
    { code: '1640-76-710', name: 'Product Development' },
    { code: '1640-76-740', name: 'Development/CTU materials' },
    { code: '4510-50-510', name: 'BICSI Gear' },
    { code: '6130-73-740-1', name: 'Training' },
    { code: '6140-70-706', name: 'Comp Mn-Credentialing' },
    { code: '6140-70-710', name: 'Comp Manual PD&C' },
    { code: '6140-72-700', name: 'Comp Manual - publications' },
    { code: '6140-72-770', name: 'Comp-Essdrm4th-Dev' },
    { code: '6140-73-740-1', name: 'TD&O' },
    { code: '6140-74-785', name: 'Comp Standards Dept.' },
    { code: '6210-10-105', name: 'Executive' },
    { code: '6210-10-110', name: 'Board of Directors' },
    { code: '6210-10-120', name: 'Ethics' },
    { code: '6210-10-130', name: 'Government Relations' },
    { code: '6210-10-150', name: 'BICSI Cares' },
    { code: '6210-10-160', name: 'Past Pres. Council' },
    { code: '6210-10-170', name: 'Presdent Activites' },
    { code: '6210-10-175', name: 'President Elect Activites' },
    { code: '6210-20-200', name: 'Admin & Finance' },
    { code: '6210-20-205', name: 'Facilities' },
    { code: '6210-20-210', name: 'Human Res.' },
    { code: '6210-20-215', name: 'IT DEPT.' },
    { code: '6210-20-220', name: 'Finance Cmmtte' },
    { code: '6210-30-300', name: 'Conference and Mtgs' },
    { code: '6210-30-310', name: 'Fall' },
    { code: '6210-30-320', name: 'Winter' },
    { code: '6210-30-325', name: 'Canadian Conference' },
    { code: '6210-30-330', name: 'Spring' },
    { code: '6210-40-400', name: 'International' },
    { code: '6210-40-405', name: 'Africa' },
    { code: '6210-40-406', name: 'MEA Conference' },
    { code: '6210-40-410', name: 'Brasil' },
    { code: '6210-40-412', name: 'CALA' },
    { code: '6210-40-415', name: 'Canada' },
    { code: '6210-40-416', name: 'Caribbean' },
    { code: '6210-40-420', name: 'Europe UK & Ireland' },
    { code: '6210-40-422', name: 'Europe Mainland' },
    { code: '6210-60-670', name: 'US - Western Region' },
    { code: '6210-60-680', name: 'Canada Region Mttg' },
    { code: '6210-60-685', name: 'Europe Region' },
    { code: '6210-60-690', name: 'Meeting Services' },
    { code: '6210-70-700', name: 'Professional Dev' },
    { code: '6210-70-740-2', name: 'Installation Exams' },
    { code: '6210-71-700', name: 'Credentialing' },
    { code: '6210-72-700', name: 'Multiple Manuals' },
    { code: '6210-72-710-4', name: 'Tdmm15th' },
    { code: '6210-72-712-4', name: 'TPMRM-2' },
    { code: '6210-72-713-4-', name: 'EDCP Manual' },
    { code: '6210-72-713-4', name: 'EBG-V2' },
    { code: '6210-72-730-4', name: 'Osp6th' },
    { code: '6210-72-740-4', name: 'Itsim8th' },
    { code: '6210-72-740-4-', name: 'Field Guides' },
    { code: '6210-73', name: 'Class Materials' },
    { code: '6210-73-700', name: 'Operations' },
    { code: '6210-73-710-1', name: 'Design Template' },
    { code: '6210-73-710-5', name: 'Design Workbooks' },
    { code: '6210-73-740-1', name: 'Installation Supplies' },
    { code: '6210-73-740-5', name: 'Installation Workbooks' },
    { code: '6210-73-790', name: 'ATF/Certificates' },
    { code: '6210-74-785-7', name: 'Multiple Standards' },
    { code: '6210-80-800', name: 'Sales' },
    { code: '6250-72-700-4', name: 'TPRMRM Development' },
    { code: '6250-72-730-4', name: 'Osp 6th Development' },
    { code: '6250-72-730-9', name: 'TPD Development' },
    { code: '6890-10-165', name: 'BICSI OLC' },
    { code: '74-785-7-ZN0G1', name: 'G1-17 Standard' },
    { code: '74-785-7-ZN0N1', name: 'N1-19' },
    { code: '74-785-7-ZN0N2', name: 'N2-17 Standard' },
    { code: '74-785-7-ZN568', name: '568 Standard' },
    { code: '74-785-7-ZN607', name: '607 Standard' },
    { code: '6210-74-785-7-Z0G2', name: 'G2.1 Standard' },
    { code: '6210-74-785-7-ZG22', name: 'G2.2' },
    { code: '6210-74-785-7-Z0G4', name: 'G4-23 Standard' },
    { code: '6210-72-730-4-', name: 'OSPDE' },
    { code: '74-785-7-Z0001', name: '001 Standard' },
    { code: '74-785-7-Z0002', name: 'Data Center Standard' },
    { code: '74-785-7-Z0003', name: 'BIM Standard' },
    { code: '74-785-7-Z0004', name: 'Healthcare Standard' },
    { code: '74-785-7-Z0006', name: 'DAS Standard' },
    { code: '74-785-7-Z0007', name: '007 Standard' },
    { code: '74-785-7-Z0008', name: '008 Standard' },
    { code: '74-785-7-Z0009', name: '009 Standard' },
    { code: '74-785-7-Z0N3', name: 'N3 Standard' }
]
